import { Directive } from '@angular/core';
import { ShowOnEnterDirective } from './show-on-enter.directive';

@Directive({
  selector: '[showright]',
  standalone: true,
})
export class ShowrightDirective extends ShowOnEnterDirective {
  protected override readonly direction = 'right';
}
